<template>
  <div class="popup" v-cloak v-if="tipShow">
    <div class="content" id="googlePhotosV2Tips" :language="this.$i18n.locale">
      <div class="title">
        <span>{{$t('language.popup.cloudExploerPopup.googlePhotosV2Tips')}}</span>
        <div class="icon white-close dialog-close" @click="closeDeal()"></div>
      </div>
      <div class="tips-content">
        <div>{{$t('language.popup.cloudExploerPopup.googlePhotosV2TipsDesc')}}</div>
        <ol>
          <li>{{$t('language.popup.cloudExploerPopup.googlePhotosV2Tips1')}}</li>
          <li>{{$t('language.popup.cloudExploerPopup.googlePhotosV2Tips2')}}</li>
          <li>{{$t('language.popup.cloudExploerPopup.googlePhotosV2Tips3')}}</li>
          <li>{{$t('language.popup.cloudExploerPopup.googlePhotosV2Tips4')}}</li>
        </ol>
      </div>
      <div class="tips-footer">
        <div @click="isChecked = !isChecked">
          <div class="icon-util" :class="isChecked ? 'check-small' : 'nocheck-small'"></div>
          <div>{{$t('language.popup.cloudExploerPopup.googlePhotosV2TipsShow')}}</div>
        </div>
        <br>
        <button class="whilt" @click="closeDeal()">{{$t('language.common.cancel')}}</button>
        <button @click="okDeal()">{{$t('language.common.ok')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
  data: function () {
    return {
      tipShow: false,
      isChecked: false,
    }
  },
  methods: {
    // 新手引导
    guidance() {
      let cookieKey = "googlePhotosV2TipsManage" + commonUtils.getUser().id;
      let isNew = this.$cookies.get(cookieKey) != "Y";
      if (isNew) {
        this.$store.state.googleGuideFlag = true;
        this.$cookies.set(cookieKey, "Y", "1y");
      }
    },
    closeDeal() { 
      this.tipShow = false
      this.guidance();
    },
    okDeal() {
      this.tipShow = false
      if (this.isChecked) {
        this.$cookies.set("googlePhotosV2Tips" + commonUtils.getUser().id, "Y", "1y");
      }
      this.guidance();
    },
  }
}
</script>

<style scoped>
#googlePhotosV2Tips {
  width: 450px;
  height: 510px;
}

#googlePhotosV2Tips[language=deutsch] {
  height: 530px;
}
#googlePhotosV2Tips[language=france] {
  height: 550px;
}
#googlePhotosV2Tips[language=nederlands] {
  height: 530px;
}
#googlePhotosV2Tips[language=traditionalChinese] {
  height: 410px;
}
#googlePhotosV2Tips[language=chinese] {
  height: 395px;
}

.tips-content {
  width: 100%;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  line-height: 20px;
}

.tips-content>div {
  margin-top: 20px;
}

.tips-content>ol {
  padding-left: 15px;
}

.tips-content>ol>li {
  margin-top: 10px;
}

.tips-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  text-align: center;
}

.tips-footer>button {
  margin: 0 20px;
  min-width: 100px;
}

.tips-footer>div {
  padding-top: 10px;
  padding-bottom: 20px;
  color: rgba(0, 0, 0, 0.6);
  cursor: default;
  display: inline-block;
}

.tips-footer>div>div {
  display: inline-block;
  vertical-align: middle;
}

.whilt {
  background-color: #FFF;
  color: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.whilt:hover {
  background-color: #3250c9;
  color: #FFF;
  border: none;
}

.whilt:active {
  background-color: #5166BD;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/google_photos_v2_tips_popup.vue